$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('home-category')) {
    customElements.define(
      'home-category',
      class aboutApplicationScenarios extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          const $mySwiper = this.querySelector('.home-category_swiper');
          const $next = this.querySelector('.home-category_next');
          const $prev = this.querySelector('.home-category_prev');
          const $mySwiperWidth = $($mySwiper).width();
          if ($mySwiperWidth < $($mySwiper).parent().width()) {
            $($next).addClass('hidden');
          }

          const swiper = new Swiper($mySwiper, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            on: {
              slideChange: function () {
                if (this.isBeginning) {
                  $($prev).removeClass('flex').addClass('hidden');
                } else {
                  $($prev).removeClass('hidden').addClass('flex');
                }
                if (this.isEnd) {
                  $($next).addClass('hidden');
                } else {
                  $($next).removeClass('hidden');
                }
              },
            },
            navigation: {
              nextEl: $next,
              prevEl: $prev,
            },
          });
        }
      }
    );
  }
});
